import { render, staticRenderFns } from "./AboutHeader.vue?vue&type=template&id=e8332792&scoped=true"
import script from "./AboutHeader.vue?vue&type=script&lang=ts"
export * from "./AboutHeader.vue?vue&type=script&lang=ts"
import style0 from "./AboutHeader.vue?vue&type=style&index=0&id=e8332792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8332792",
  null
  
)

export default component.exports